module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("number format")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("numberComma")]), _vm._v("用于分割数字，默认为3位分割，一般用于格式化"), _c('code', [_vm._v("金额")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("numberPad")]), _vm._v("用于按照位数补0")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("numberRandom")]), _vm._v("用于生成两个整数范围内的随机整数")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { numberComma, numberPad, numberRandom } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nnumberComma("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("21342132")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 21,342,132")]), _vm._v("\nnumberComma("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("21342132")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("4")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 2134,2132")]), _vm._v("\nnumberComma("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("21342132.234")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 21,342,132.234")]), _vm._v("\n\nnumberPad("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 01")]), _vm._v("\nnumberPad("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("234")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("4")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 0234")]), _vm._v("\n\nnumberRandom("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("7")]), _vm._v(") "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 2")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a15c026", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-2a15c026"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/number-180.vue
// module id = 2105
// module chunks = 417